import React, { Component } from "react";
import { connect } from "react-redux";
import { FiPlus, FiHeart } from "react-icons/fi";
import { FaRegBell, FaHeart } from "react-icons/fa";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { FiMoreHorizontal } from "react-icons/fi";
import * as groupsActions from "actions/groupsActions";
import NotificationEditModal from "components/Dashboard/Modals/NotificationEditModal";
import NotificationLikesModal from "components/Dashboard/Modals/NotificationLikesModal";
import { notificationsService } from "services";
import { isAdmin, isSupervisor } from "utils/utils";
import { showModal, hideModal } from "actions/modalActions";
import { withTranslation } from "react-i18next";

// Helpers
const isLikedByMe = (notification, myUserId) =>
	Array.isArray(notification?.liked_by) &&
	notification.liked_by.some((u) => u.id === myUserId);

const likesCount = (notification) =>
	Array.isArray(notification?.liked_by) ? notification.liked_by.length : 0;

const canManageNotification = (noti, user) => {
	if (isAdmin()) return true;

	const supervisedIds = (user?.groups_supervised || []).map((g) => g.id);
	const notiGroupIds = (noti.groups || []).map((g) => g.id);

	return notiGroupIds.some((id) => supervisedIds.includes(id));
};

class Dashboard_Notifications extends Component {
	constructor(props) {
		super(props);
		this.state = {
			notifications: [],
			hasSuperPowers: isAdmin() || isSupervisor(),
			// likes modal
			likesModalOpen: false,
			likesModalNotificationId: null,
			likesSearch: "",
		};

		this.closeModal = this.closeModal.bind(this);
		this.openNewNotificationModal = this.openNewNotificationModal.bind(this);
		this.openEditNotificationModal = this.openEditNotificationModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getNotifications = this.getNotifications.bind(this);
	}

	componentDidMount() {
		this.getNotifications();
		this.getGroups();
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewNotificationModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("widgets.notifications.newNotification"),
				style: { width: "650px" },
				content: (
					<NotificationEditModal
						getNotifications={this.getNotifications}
						getAttachment={this.getAttachment}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditNotificationModal(notification) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("widgets.notifications.editNotification"),
				style: { width: "650px" },
				content: (
					<NotificationEditModal
						getNotifications={this.getNotifications}
						getAttachment={this.getAttachment}
						notification={notification}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteNotificationModal(idNotification) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				style: { width: "350px" },
				title: t("widgets.notifications.deleteNotification"),
				message: t("widgets.notifications.deleteConfirm"),
				deleteAction: () => this.confirmDelete(idNotification),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}
	openAlertModal(message) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("widgets.notifications.deleteError"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idNotification) => {
		const response = await notificationsService.remove(idNotification);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getNotifications();
			this.closeModal();
		}
	};

	async getNotifications() {
		try {
			const response = await notificationsService.getAll();

			if (response && response.ok) {
				this.setState({
					notifications: response.data,
					loading: false,
				});
			} else {
				// Si la respuesta no es ok, inicializar con arrays vacíos
				this.setState({
					notifications: [],
					loading: false,
				});
			}
		} catch (error) {
			// Manejar errores de red o de petición
			console.error("Error al cargar comunicaciones:", error);
			this.setState({
				notifications: [],
				loading: false,
			});
		}
	}

	async getGroups() {
		await this.props.getAllGroups();
	}

	getCardTop = () => {
		const { t } = this.props;
		return (
			<div className="heading">
				<h2>{t("widgets.notifications.title")}</h2>
				{this.state.hasSuperPowers && (
					<div className="heading-actions">
						<button
							type="button"
							title={t("widgets.notifications.addNotification")}
							onClick={this.openNewNotificationModal}
							className="btn btn-new btn-new-small"
						>
							<FiPlus />
						</button>
					</div>
				)}
			</div>
		);
	};

	getAttachment = async (notification, attachment) => {
		const blob = await notificationsService.getAttachment(
			notification.id,
			attachment.url
		);

		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = attachment.name || "adjunto";
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
	};

	openLikesModal = (notificationId) => {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("widgets.notifications.like"),
				style: { width: "420px" },
				content: (
					<NotificationLikesModal
						notificationId={notificationId}
						notifications={this.state.notifications}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	renderLike = (noti) => {
		const myUserId = this.props.user.id;
		const liked = isLikedByMe(noti, myUserId);
		const count = likesCount(noti);

		return (
			<div className="like-wrap">
				<button
					type="button"
					className={`btn-like ${liked ? "liked" : ""}`}
					onClick={() => this.handleToggleLike(noti)}
					title={liked ? this.props.t("widgets.notifications.unlike") : this.props.t("widgets.notifications.like")}
				>
					<span className="like-icon">{liked ? <FaHeart /> : <FiHeart />}</span>
				</button>

				{/* el contador abre el modal */}
				<button
					type="button"
					className="btn-like-count"
					disabled={count === 0}
					onClick={() => this.openLikesModal(noti.id)}
					title={count === 0 ? "" : this.props.t("widgets.notifications.viewLikes")}
				>
					{count}
				</button>
			</div>
		);
	};

	handleToggleLike = async (noti) => {
		const myUserId = this.props.user.id;
		const currentlyLiked = isLikedByMe(noti, myUserId);

		const likeLoading = this.state.likeLoading || {};
		if (likeLoading[noti.id]) return;

		this.setState((prev) => ({
			likeLoading: { ...(prev.likeLoading || {}), [noti.id]: true },
		}));

		try {
			const updated = await notificationsService.setLike(
				noti.id,
				!currentlyLiked
			);

			this.setState((prev) => ({
				notifications: prev.notifications.map((n) =>
					n.id === updated.id ? updated : n
				),
				likeLoading: { ...(prev.likeLoading || {}), [noti.id]: false },
			}));
		} catch (e) {
			console.error("Like/unlike error:", e);
			this.setState((prev) => ({
				likeLoading: { ...(prev.likeLoading || {}), [noti.id]: false },
			}));
		}
	};

	getContent = () =>
		this.state.notifications.map((noti, i) => {
			const canManage = canManageNotification(noti, this.props.user);

			const attachments =
				noti.attachments &&
				noti.attachments.length > 0 &&
				noti.attachments.map((attachment) => {
					let size = attachment.size / 1000000;
					let sizeLetters = "Mb";

					if (size < 1) {
						size = attachment.size / 1000;
						sizeLetters = "Kb";
					}

					return (
						<li className="file-item" key={attachment.url}>
							<span
								className="file-info"
								title={attachment.name}
								onClick={() => this.getAttachment(noti, attachment)}
							>
								<span className="file-name">{attachment.name}</span>
								<span className="file-size">
									({size.toFixed(2)}
									{sizeLetters})
								</span>
							</span>
						</li>
					);
				});

			return (
				<article key={i} className="notification">
					<span className="notification-icon">
						<FaRegBell />
					</span>
					<div className="notification-main">
						<div className="notification-header">
							<h3 className="notification-title">
								{noti.title}
								<span className="notification-date">
									{noti.created
										? moment(noti.created).format("D MMM")
										: "-"}
								</span>
							</h3>
							{canManage && (
								<Dropdown>
									<Dropdown.Toggle variant="action">
										<FiMoreHorizontal />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											as="button"
											onClick={() => this.openEditNotificationModal(noti)}
										>
											{this.props.t("common.edit")}
										</Dropdown.Item>
										<Dropdown.Item
											as="button"
											onClick={() => this.openDeleteNotificationModal(noti.id)}
										>
											{this.props.t("common.delete")}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							)}
						</div>
						<p className="notification-body">{noti.body}</p>
						{attachments && (
							<ul className="notification-files">{attachments}</ul>
						)}
						<div className="notification-footer">{this.renderLike(noti)}</div>
					</div>
				</article>
			);
		});

	render() {
		const { notifications } = this.state;

		return (
			<>
				<div className="card-top">{this.getCardTop()}</div>
				<div className="card-content">
					{notifications.length > 0 ? (
						this.getContent()
					) : (
						<div className="empty">
							<FaRegBell />
							<p>{this.props.t("widgets.notifications.noNotifications")}</p>
						</div>
					)}
				</div>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllGroups: () => dispatch(groupsActions.getAllGroups({ sort: "+name" })),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(Dashboard_Notifications));
